import ListYourShowForm from "../../../listYourShow/ListYourShowForm.jsx";

/**
 * Admin / superadmin create event uses the same multi-step List Your Show form.
 * After create, returns to the admin events list.
 */
export default function AdminEventForm() {
  return (
    <ListYourShowForm
      successRedirect="/admin/events"
      exitTo="/admin/events"
    />
  );
}
